var map = {
	"./Answers&Solutions_NEET-2024_(Code-Q1)_FINAL.pdf": 17247,
	"./Answers&Solutions_NEET-2024_(Code-Q2)_FINAL.pdf": 98350,
	"./NEET-UG  2024 R6.pdf": 43522,
	"./NEET-UG  2024.pdf": 32310,
	"./Qs&Ans_NEET-2024 (BookletCode-Q3).pdf": 97166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32635;